<template>
  <div id="viewIdle11" style="padding-bottom:30px" v-if="tabdata">
    <div class="viewIdle_box">
      <div class="box">
        <el-row>
          <el-col :span="7">
            <el-image
              style="width:300px;height:300px"
              class="cover"
              :src="tabdata.res.image"
              fit="cover"
            ></el-image>
          </el-col>
          <el-col :span="13">
            <div class="t1 lv1Text">{{tabdata.res.name}}</div>
            <div style="font-size:16px;line-height:30px">专利号 : {{tabdata.res.code}}</div>
            <div class="b1 lv3Text">
              <div class="t2">
                出售价格 :
                <span>
                  <span style="margin:0 18px 0 24px">&yen;</span>
                  <span style="font-size:30px;font-weight:bold;color:#e2211c">{{tabdata.res.price}}</span>
                </span>
              </div>
            </div>
            <div class="d1 clearfix">
              <div class="collect" @click="collect = true" :class="collect ? 'collect_active' : ''">
                <!-- <i class="iconfont icon-shoucang" style="font-size:14px;"></i> -->
                <i class="iconfont icon-shoucang1" style="font-size:14px;margin-right:4px"></i>
                <span>收藏</span>
              </div>
              <a
                href="https://www.bioflin.com:83/qr_code.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div class="btn">
                  <el-button plain>立即咨询</el-button>
                </div>
              </a>
              <a
                style="float:left;margin:12px 16px 0 24px"
                target="blank"
                href="http://wpa.qq.com/msgrd?v=3&uin=1653120607&site=qq&menu=yes"
              >
                <img
                  border="0"
                  src="http://wpa.qq.com/pa?p=2:1653120607:51"
                  alt="点我咨询"
                  title="点我咨询"
                  height="25"
                />
              </a>
              <div style="float:left;margin:12px 16px 0 12px">
                <el-popover placement="bottom" width="240" trigger="hover" @show="imageType">
                  <p>
                    <img :src="serve  + images " alt />
                  </p>
                  <div
                    slot="reference"
                    style="cursor: pointer;  display:inline-block;*zoom:1;display:inline;width:30px"
                  >
                    <i class="fab fa-weixin fa-2x" style="color:#88c512;"></i>
                  </div>
                </el-popover>
              </div>
            </div>

            <el-row class="patent_tetx" :gutter="50">
              <div class="patent_tetx_soild"></div>
              <div class="patent_tetx_soild1"></div>
              <div class="patent_tetx_soild2"></div>

              <el-col :span="6">
                <p>{{tabdata.res.type=== '1' ? '国际专利' : '国内专利'}}</p>
                <div>专利类型</div>
              </el-col>

              <el-col :span="6">
                <p>生物</p>
                <div>行业分类</div>
              </el-col>

              <el-col :span="6">
                <p>出售商品</p>
                <div>交易类型</div>
              </el-col>
              <el-col :span="6">
                <p v-if="tabdata.res.status === '1'">待融资</p>
                <p v-if="tabdata.res.status === '2'">已融资</p>
                <p v-if="tabdata.res.status === '3'">待交易</p>
                <p v-if="tabdata.res.status === '4'">已交易</p>
                <div>专利状态</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <div style="margin: 60px  20px">
              <div style="border:1px solid rgba(221, 221, 221, 1);">
                <qrcode-vue
                  style="padding:5px 5px"
                  :value="'https://www.bioflin.com/#'+ $route.fullPath"
                  :size="140"
                  level="H"
                ></qrcode-vue>
              </div>
              <div style="text-align:center;padding-top:10px">扫码分享商品</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="box2">
        <el-row :gutter="20">
          <el-col :span="19">
            <div class="col">
              <div
                class="lv1Text"
                style="font-size:20px;text-align:center;padding-top:40px;color:#243159;"
              >专利信息</div>
              <div style="width:850px;margin:30px auto 0px  auto">
                <el-table :data="arr" border style="width: 100%">
                  <el-table-column align="center" label="专利号">
                    <template>{{tabdata.res.code}}</template>
                  </el-table-column>
                  <el-table-column align="center" label="专利名称">
                    <template>{{tabdata.res.name}}</template>
                  </el-table-column>
                  <el-table-column align="center" label="专利类型">
                    <template>{{tabdata.res.type=== '1' ? '国际专利' : '国内专利'}}</template>
                  </el-table-column>
                  <el-table-column align="center" label="行业分类">
                    <template>生物</template>
                  </el-table-column>
                  <el-table-column align="center" label="申请日期">
                    <template>{{by_time}}</template>
                  </el-table-column>
                  <el-table-column align="center" label="有效期至">
                    <template>{{tabdata.res.end_time}}</template>
                  </el-table-column>
                  <el-table-column align="center" label="专利状态">
                    <template>
                      <span v-if="tabdata.res.status === '1'">待融资</span>
                      <span v-if="tabdata.res.status === '2'">已融资</span>
                      <span v-if="tabdata.res.status === '3'">待交易</span>
                      <span v-if="tabdata.res.status === '4'">已交易</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div
                class="lv1Text"
                style="font-size:20px;text-align:center;padding-top:40px;color:#243159;"
              >专利详情</div>
              <div
                class="iinnfo"
                style="padding:50px;word-wrap:break-word;border:1px; "
                v-html="tabdata.res.info"
              ></div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="share_right">
              <div class="share_right_tit">专利相关推荐</div>
              <div
                align="center"
                style="background:#fff;margin-bottom:15px"
                v-for="(item,index) of tabdata.recommend"
                :key="index"
                class="share_right_list"
              >
                <router-link :to="'/patent_details?id='+item.id">
                  <el-image
                    class="cover2"
                    style="width: 200px; height: 200px;padding-top:15px;"
                    :src="item.image"
                    fit="cover"
                  ></el-image>
                </router-link>
                <div class="title">
                  <router-link :to="'patent_details?id='+item.id">{{item.name}}</router-link>
                </div>
                <div class="patent">{{item.type=== '1' ? '国际专利' : '国内专利'}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      images: "",
      collect: false,
      serve: this.$store.state.serve,
      id: this.$route.query.id,
      tabdata: null,
      arr: [
        {
          code: "",
          name: "",
          type: "",
          class: "生物",
          create_date: "",
          end_time: "",
          status: ""
        }
      ]
    };
  },
  created() {
    this.initData();
  },

  methods: {
    imageType() {
      this.axios.get(this.serve + "/guanwei_img").then(res => {
        if (res.data.status == "success") {
          this.images = res.data.data;
        }
      });
    },
    success(msg) {
      this.$message.success({
        type: "success",
        message: msg,
        offset: 150
      });
    },
    initData() {
      this.axios
        .get(this.serve + "/infoPatent", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          if (res.data.status === "success") {
            this.tabdata = res.data.data;
          }
        });
    }
  },
  // .slice().indexOf(' ')
  computed: {
    by_time() {
      return new Date(parseInt(this.tabdata.res.create_date) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ")
        .slice(
          0,
          new Date(parseInt(this.tabdata.res.create_date) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ")
            .indexOf(" ")
        );
    }
    //  ex_time() {
    //    return new Date(parseInt(this.data.results.create_date) * 1000)
    //      .toLocaleString()
    //      .replace(/:\d{1,2}$/, " ")
    //      .slice(
    //        0,
    //        new Date(parseInt(this.data.results.create_date) * 1000)
    //          .toLocaleString()
    //          .replace(/:\d{1,2}$/, " ")
    //          .indexOf(" ")
    //      );
    //  }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#viewIdle11 {
  width: 100%;
  border-top: 2px solid #e2211c;

  .viewIdle_box {
    width: 1200px;
    margin: 20px auto 0 auto;
    .box {
      height: 340px;
      background-color: #fff;
      padding: 40px 0 0 40px;
    }
  }
  .d2:hover a {
    color: #e2211c;
  }
  .d2 {
    padding: 10px 0 30px 0;
  }
  .d3 {
    padding: 2px 0 10px 0;
  }
  .top4-item {
    background: #fff;
    margin-bottom: 20px;
  }
  .c1 {
    margin-bottom: 20px;
  }
  .name {
    line-height: 50px;
  }
  .d1 {
    margin-top: 20px;
    width: 100%;
    .collect {
      float: left;
      line-height: 40px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
    }
    .collect:hover {
      color: #e2211c;
    }
    .collect_active {
      color: #e2211c;
    }
    .btn {
      float: left;
      button {
        width: 158px;
        margin-left: 50px;
      }
    }
  }
  .patent_tetx {
    /* width: 100%; */
    margin-top: 25px;
    text-align: left;
    position: relative;
    .patent_tetx_soild {
      width: 1px;
      height: 30px;
      background: rgba(221, 221, 221, 1);
      position: absolute;
      left: 136px;
      top: 24px;
    }
    .patent_tetx_soild1 {
      width: 1px;
      height: 30px;
      background: rgba(221, 221, 221, 1);
      position: absolute;
      left: 300px;
      top: 24px;
    }
    .patent_tetx_soild2 {
      width: 1px;
      height: 30px;
      background: rgba(221, 221, 221, 1);
      position: absolute;
      left: 480px;
      top: 24px;
    }
    p {
      font-size: 16px;
      color: rgba(102, 102, 102, 1);
    }
    div {
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
    }
  }
  .avatar {
    border-radius: 50px;
    overflow: hidden;
  }
  .box2 {
    margin-top: 20px;
    .iinnfo {
      table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
      }
      table td,
      table th {
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        padding: 3px 5px;
      }
      table th {
        border-bottom: 2px solid #ccc;
        text-align: center;
      }
    }
    .share_right {
      width: 100%;
      .share_right_tit {
        font-size: 16px;
        font-family: "Microsoft YaHei";
        text-align: center;
        font-weight: 400;
        height: 50px;
        line-height: 50px;
        color: #2b3d63;
        background: #fff;
        margin-bottom: 1px;
      }
      .share_right_list {
        width: 100%;
        height: 320px;
        .title {
          white-space: nowrap;
          padding: 15px 0 15px 0px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .title:hover a {
          color: #e2211c;
        }
        .patent {
          border-top: 1px solid #dddddd;
          font-weight: 400;
          height: 56px;
          line-height: 56px;
          color: #e2211c;
          text-align: center;
        }
      }
    }
    .col {
      background-color: #fff;
      width: 100%;
    }
  }
  .t1 {
    font-size: 30px;
    font-size: 24px;
    color: rgba(51, 51, 51, 1);
  }
  .b1 {
    font-size: 14px;
    height: 98px;
    background: #f5f5f5;
    .t2 {
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 98px;
      padding-left: 10px;
    }
    /* div {
      padding: 10px 0 10px 20px;
    } */
  }
  /* .b2 {
    font-size: 14px;
    height: 196px;
    background: rgba(221, 221, 221, 1);
    color: #333333;
    div {
      padding: 12px 0 0px 20px;
    }
  } */
}
</style>

